import React, { useMemo } from 'react'
import { Button } from '@ow/comps'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { pick } from 'lodash-es'
import BatchAdd from '../areas/batchAdd'
import BatchDelete from '../areas/batchDelete'
import Tree from '../areas/tree'
import useAreaStore from '../areas/areaStore'
import CheckedIcon from '../areas/checkedIcon'
import BindModal from '../areas/binding/bindModal'
import Exporter from '../areas/exporter'
import { useProjectValidator } from '../areas/hooks/tab'
import { useBindStore } from './BindProvider'

const Control = function ({ type }) {
  const title = type === 'area' ? '点位' : '指标'

  const { isCreateAreaBind, objectIdsBindedList, isBatchDelete, setAreaState } =
    useAreaStore((state) =>
      pick(state, [
        'isCreateAreaBind',
        'objectIdsBindedList',
        'isBatchDelete',
        'setAreaState',
      ])
    )

  const {
    setTbData,
    clickedInfo,
    setClickedInfo,
    setSelectedIds,
    selectedIds,
    ditto,
    tbData,
  } = useTbViewStore((state) =>
    pick(state, [
      'tbData',
      'setClickedInfo',
      'clickedInfo',
      'selectedIds',
      'setTbData',
      'setSelectedIds',
      'ditto',
    ])
  )
  const { tbs } = useAppEx((x) => pick(x, ['tbs']))
  const { isCalStandards } = useBindStore((state) =>
    pick(state, ['isCalStandards'])
  )

  const tbDataWithIcon = useMemo(() => {
    // 绑定用户状态
    if (isCreateAreaBind) {
      if (!objectIdsBindedList.length) return tbData

      return tbData.map((item) => ({
        ...item,
        icon: objectIdsBindedList.includes(item.objectId) ? (
          <CheckedIcon />
        ) : null,
      }))
    }

    // 绑定表单字段状态
    const targetBindMap = {}
    Object.values(tbs).forEach((tb) => {
      if (tb.enableStandardBind) {
        const { bindMap } = ditto.getBindMap
          ? ditto.getBindMap(tb.tbId)
          : { bindMap: {} }
        Object.assign(targetBindMap, bindMap)
      }
    })

    if (!Object.keys(targetBindMap).length) return tbData

    return tbData.map((item) => ({
      ...item,
      icon: targetBindMap[item.objectId] ? <CheckedIcon /> : null,
    }))
  }, [tbData, tbs, isCreateAreaBind, objectIdsBindedList])

  const { multiSelect = false, clickedId = null } = clickedInfo

  const startDelete = () => {
    setAreaState({ isBatchDelete: true })
  }

  const isNormal = !isCreateAreaBind && !multiSelect && !isBatchDelete

  const projectValidator = useProjectValidator()

  return (
    <div>
      <div className="pt-5 pb-3 px-3 flex justify-between flex-wrap">
        <div>指标管理</div>
        <div className="flex items-center gap-2 flex-wrap">
          {isNormal && (
            <>
              <BatchAdd
                title={title}
                type={type}
                refreshTreeData={(data) => {
                  setTbData(tbData.concat(data))
                }}
              >
                <Button className="h-6" type="primary" size="sm">
                  添加指标
                </Button>
              </BatchAdd>
              {projectValidator('ref') && (
                <Button
                  className="h-6"
                  type="primary"
                  size="sm"
                  stroke
                  onClick={() => {
                    setClickedInfo({
                      ...clickedInfo,
                      selectedKeys: [],
                    })
                    setSelectedIds([])
                    setTimeout(() => {
                      setClickedInfo({
                        ...clickedInfo,
                        multiSelect: true,
                      })
                    }, 100)
                  }}
                >
                  批量关联
                </Button>
              )}
              <Button className="h-6" size="sm" stroke onClick={startDelete}>
                批量删除
              </Button>
            </>
          )}
          {isCreateAreaBind && (
            <BindModal isMulti>
              <Button
                className="h-6"
                size="sm"
                stroke
                disabled={selectedIds.length === 0}
              >
                批量绑定
              </Button>
            </BindModal>
          )}
          {multiSelect && (
            <Button
              className="h-6"
              type="primary"
              size="sm"
              stroke
              onClick={() => {
                setClickedInfo({
                  ...clickedInfo,
                  multiSelect: false,
                  selectedKeys: [clickedId],
                })
                setSelectedIds([])
              }}
            >
              取消
            </Button>
          )}
          {isBatchDelete && <BatchDelete type="standard" />}
          <Exporter type="指标" />
        </div>
      </div>
      <Tree
        tbData={tbDataWithIcon}
        selectable={!multiSelect || !isCalStandards} // 统计计算的时候不允许切换
        checkable={!isNormal || isCalStandards}
        checkStrictly={isBatchDelete}
      />
    </div>
  )
}

export default Control
